import { useEffect, useState } from "react";

const geoServices = [
  {
    name: "ipapi",
    url: "https://ipapi.co/json/",
    extract: (data) => ({
      country: data.country,
      countryName: data.country_name
    })
  },
  {
    name: "ip-api",
    url: "https://ip-api.com/json",
    extract: (data) => ({
      country: data.countryCode,
      countryName: data.country
    })
  },
  {
    name: "geojs",
    url: "https://get.geojs.io/v1/ip/geo.json",
    extract: (data) => ({
      country: data.country_code,
      countryName: data.country
    })
  }
];

const getGeolocationFallback = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject("No geolocation");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
          );
          const data = await response.json();
          resolve({
            country: data.address.country_code?.toUpperCase(),
            countryName: data.address.country
          });
        } catch {
          reject("Reverse geocoding failed");
        }
      },
      () => reject("Geolocation access denied")
    );
  });
};

export default function useDetectCountry() {
  const [country, setCountry] = useState(null);

  useEffect(() => {
    const detect = async () => {
      for (const service of geoServices) {
        try {
          const res = await fetch(service.url);
          if (!res.ok) continue;
          const data = await res.json();
          const location = service.extract(data);
          if (location.country) {
            setCountry(location.country);
            return;
          }
        } catch {
          continue;
        }
      }

      try {
        const geoData = await getGeolocationFallback();
        setCountry(geoData.country);
      } catch {
        console.log("All geolocation attempts failed.");
      }
    };

    detect();
  }, []);

  return country;
}
